import React, { useState, useEffect, useRef } from "react";
import { Table, Spin, Badge, Modal, Select, Input, Form, Button, message, Space, Tooltip, Dropdown, DatePicker, } from "antd";
import TextArea from "antd/es/input/TextArea";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import { FaCirclePlus } from "react-icons/fa6";
import { Timesheetapi } from "../../middleware/interceptor";
import dayjs from 'dayjs';
import { FaRegEdit } from "react-icons/fa";
import { FaTrashAlt } from "react-icons/fa";
import { FaArrowLeft } from 'react-icons/fa';
import { DownOutlined } from '@ant-design/icons';
import { Description } from "@mui/icons-material";
import utc from 'dayjs/plugin/utc';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'


const Ticket = ({ }) => {
  const clientId = 1014;
  dayjs.extend(utc);
  dayjs.extend(isSameOrAfter);
  dayjs.extend(isSameOrBefore);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedValue, setSelectedValue] = useState(clientId);
  const [form] = Form.useForm();
  const [members, setmembers] = useState([]);
  const [Reqstatus, setReqstatus] = useState([]);

  const [edit, setEdit] = useState(false);

  const [Requirements, setRequirements] = useState([]);

  const [RequirementsList, setRequirementsList] = useState([]);
  const [filterRequirementsList, setFilterRequirementsList] = useState([])
  const [clientname, setClientname] = useState('');
  const [clients, setClient] = useState([]);
  const [updatepayload, setupdatepayload] = useState({})

  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [workItemType, setWorkItemType] = useState([]);
  const [workItemState, setWorkItemState] = useState([]);

  const [loading, setloading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [isAllowed, setIsAllowed] = useState(false);
  const [rawData, setRawData] = useState([]);
  const [selectedProjectTable, setSelectedProjectTable] = useState('All');
  const [selectedOwner, setSelectedOwner] = useState('All');
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 15,
  });

  const [deledata, setdeletedata] = useState()
  const handleTableChange = (newPagination) => {
    setPagination({
      current: newPagination.current,
      pageSize: newPagination.pageSize,
    });
  };

  //New
  const { RangePicker } = DatePicker;
  const [selectedAssignedToMembers, setSelectedAssignedToMembers] = useState([]);
  const [selectedclient, setSelectedClient] = useState();
  const [selectedclientfilter, setSelectedclientfilter] = useState("All");
  const [selectedprojectfilter, setSelectedprojectfilter] = useState("All");
  const [projectfilterlist, setProjectfilterlist] = useState([{
    label: "All",
    value: "All"
  }]);
  const today = new Date().toISOString().split('T')[0];
  const [sDate, setsDate] = useState(today);
  const [eDate, seteDate] = useState(today);
  const [range, setRange] = useState([dayjs(today), dayjs(today)]);

  const handleAssignedToChange = (value) => {
    const allValuesExceptAll = members
      .filter(m => m.value !== 'All')
      .map(m => m.value);

    if (value.includes('All')) {
      setSelectedAssignedToMembers(['All', ...allValuesExceptAll]);
      return;
    }

    setSelectedAssignedToMembers(prev => {
      if (prev.includes('All') && !value.includes('All')) {
        return [];
      }
      return value;
    });
  };

  // useEffect(() => {
  //   const allValuesExceptAll = members
  //     .filter(m => m.value !== 'All')
  //     .map(m => m.value);
  //   setSelectedAssignedToMembers(['All', ...allValuesExceptAll])
  // }, [members]);


  useEffect(() => {
    form.setFieldsValue({ Assigned_To: selectedAssignedToMembers });
    setTimeout(() => {
      console.log("This runs after 2 seconds", form.getFieldValue());
    }, 2000);
  }, [selectedAssignedToMembers]);


  useEffect(() => {
    console.log("SelectedAssignedto", selectedAssignedToMembers);
  }, [selectedAssignedToMembers])

  useEffect(() => {
    const getprojectFilterList = async () => {
      const response = await Timesheetapi.get(`api/projects/getRequirements?empid=${localStorage.getItem('employee_id')}&Role_Id=${localStorage.getItem('emp_role_id')}&Client_id=${selectedclientfilter}`)
      const memberOptions = response.data.Result
        .map(Team => ({
          value: Team.Project_id,
          label: Team.projectname,
        }))
      setProjectfilterlist(memberOptions);
    }

    if (selectedclientfilter != "All" && selectedclientfilter) {
      getprojectFilterList();
    }

    setSelectedprojectfilter("All")
  }, [selectedclientfilter])

  const arraysAreEqualUnordered = (a, b) => {
    return (
      Array.isArray(a) &&
      Array.isArray(b) &&
      a.length === b.length &&
      a.every(val => b.includes(val))
    );
  };


  const dateOnchange = (date, dateString) => {
    console.log(date, dateString, "DATESDATSE");
    setsDate(dateString[0]);
    seteDate(dateString[1]);
  };

  useEffect(() => {
    setmembers([])
  }, [selectedclient])


  useEffect(() => {
    const startDate = dayjs(sDate).startOf('day');
    const endDate = dayjs(eDate).endOf('day');

    const filteredData = rawData.filter(item => {
      const created = dayjs(item.Created_Date);

      const isWithinDateRange =
        created.isSameOrAfter(startDate) && created.isSameOrBefore(endDate);

      const matchesClient =
        selectedclientfilter === 'All' || item.Client_Id === selectedclientfilter;

      const matchesProject =
        selectedprojectfilter === 'All' || item.Project_Id === selectedprojectfilter;

      return (
        isWithinDateRange &&
        (selectedclientfilter === 'All' && selectedprojectfilter === 'All'
          ? true
          : selectedclientfilter === 'All'
            ? matchesProject
            : selectedprojectfilter === 'All'
              ? matchesClient
              : matchesClient && matchesProject)
      );
    });

    setFilterRequirementsList(filteredData);
  }, [sDate, eDate, rawData, selectedclientfilter, selectedprojectfilter]);


  //New End



  const handleChange = (value) => {
    setEdit(false);
    setIsModalVisible(true);
    form.setFieldsValue({
      Item_Priority: 3,
      Status: 1,
    });
    setSelectedAssignedToMembers([])
    console.log(`selected ${selectedclient}`);

  };



  // useEffect(() => {
  //   getclients();
  // },[])


  const getclientList = async () => {
    const storedClientIds = JSON.parse(localStorage.getItem('Emp_Assign_client')) || [];// Fetch data from the API
    const Role_id = JSON.parse(localStorage.getItem('emp_role_id')) || [];// Fetch data from the API
    const response = await Timesheetapi.get(`api/Projects/getProjManagerclients?empid=${localStorage.getItem('employee_id')}&clientid=${storedClientIds}`)
    const clientOptions = response.data.Client
      .filter(project => {
        if (Role_id == 6) {
          return storedClientIds.includes(project.Client_id);
        }
        return true;
      })
      .map(project => ({
        value: project.Client_id,
        label: project.Client_name,
      }))
      .filter((item, index, self) =>
        index === self.findIndex(t => t.value === item.value)
      );
    form.resetFields(["Assigned_To"])

    setClient(clientOptions);
    setmembers([])

  }

  useEffect(() => {
    const allowedClientId = localStorage.getItem("allowedClientId");
    const Callfunction = async () => {
      setIsAllowed(true);
      await getclientList()
      await getProjectList();
      await GetRequirementStatus();
    }
    Callfunction();

  }, []);




  useEffect(() => {

    if (selectedclient != null && selectedclient != "") {
      form.resetFields(["Project"])
      form.resetFields(["Assigned_To"])
      setmembers([])
      setSelectedAssignedToMembers(null)


      getprojectList()
    }
  }, [selectedclient])


  const getprojectList = async () => {
    const response = await Timesheetapi.get(`api/projects/getRequirements?empid=${localStorage.getItem('employee_id')}&Role_Id=${localStorage.getItem('emp_role_id')}&Client_id=${selectedclient}`)
    const memberOptions = response.data.Result
      .map(Team => ({
        value: Team.Project_id,
        label: Team.projectname,
      }))
    setRequirements(memberOptions);

  }




  const getProjectList = async () => {

    const storedClientIds = JSON.parse(localStorage.getItem('Emp_Assign_client')) || [];


    setloading(true)
    await Timesheetapi.get(`api/projects/getRequirementList?Client_id=${selectedclient}&&RoleId=${localStorage.getItem("emp_role_id")}&&EmpId=${localStorage.getItem("employee_id")}`).then((response) => {
      const formattedList = response.data.Req_list.map(item => ({

        ...item,
        Assigned: `${JSON.parse(item.Assigned_To_Id).length} Members`,
        Start_date: item.Start_date ? dayjs(item.Start_date).format('DD-MM-YYYY') : "-",
        End_Date: item.End_Date ? dayjs(item.End_Date).format('DD-MM-YYYY') : "-",
        Item_Priority_Id: parseInt(item.Item_Priority_Id, 10),
        Severity: parseInt(item.Severity, 10),
        Work_Item_Type: item['Work Item Type']
      }));

      setRawData(formattedList);
      setRequirementsList(formattedList);
      // setFilterRequirementsList(formattedList);
      setloading(false)
    });
  }

  const GetRequirementStatus = async () => {
    const ReqStatus = await Timesheetapi.get(`api/Projects/GetRequirementStatus`)
    const filter = ReqStatus.data.Final
      .map(Status => ({
        value: Status.Status_Id,
        label: Status.Status_Name,
      }))
      .filter((item, index, self) =>
        index === self.findIndex(t => t.value === item.value)
      );

    setReqstatus(filter);

    form.setFieldsValue({ Status: 1 });

  }




  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const toggleModal = () => {
    setIsModalVisible(!isModalVisible);
    form.resetFields();
    setSelectedAssignedToMembers([]);
    setmembers([])
  };

  const navigate = useNavigate();

  // const handleChange1 = (value) => {
  //   let temp = RequirementsList.filter(a => (value.includes(a.)||))
  // };

  // const handleChange2 = (value) => {

  // };


  const handleClientChange = async (value, option) => {
    setClientname(option.label); // Set the label in the state


    await Timesheetapi.get(`api/Projects/GetProjectWiseMember?Projectid=${value}&&Role_id=${localStorage.getItem("emp_role_id")}&&Emp_id=${localStorage.getItem("employee_id")}&&Client_id=${selectedclient}`).then((res) => {
      console.log(res.data.EmpData)
      const memberOption = res.data.EmpData
        .map(Team => ({
          value: Team.Emp_Id,
          label: Team.Emp_Name,
        }))
        .filter((item, index, self) =>
          index === self.findIndex(t => t.value === item.value)
        );
      setmembers([{ label: "All", value: "All" }, { label: "Assign to Me ", value: parseInt(localStorage.getItem("employee_id"), 10) }, ...memberOption])
      // setmembers(memberOption)
      // setRequirements(memberOption);
      // setRequirements()
      const allValuesExceptAll = [{ label: "All", value: "All" }, { label: "Assign to Me ", value: parseInt(localStorage.getItem("employee_id"), 10) }, ...memberOption]
        .filter(m => m.value !== 'All')
        .map(m => m.value);
      setSelectedAssignedToMembers(['All', ...allValuesExceptAll])

    }).catch((err) => {

    })
  };

  const handleSubmit = async (value) => {
    setSelectedProjectTable('All')
    setSelectedOwner('All')
    const formattedDateTime = dayjs().format('DD-MM-YYYY HH:mm:ss');
    const formattedEndDate = dayjs(value.end_date).format('DD-MM-YYYY');

    // Validate Assigned_To
    // const unknownUser = members.find(item => item.value == value.Assigned_To);
    // if (!unknownUser && value.Assigned_To != 1) {

    //   form.setFieldsValue({ Assigned_To: "Unknown User" });
    //   form.setFields([{
    //     name: 'Assigned_To',
    //     errors: ['This User is Not in Project or unknown.'],
    //   }]);
    //   return; // stop submission
    // }
    const cleanedAssignedTo = value.Assigned_To.includes('All')
      ? value.Assigned_To.filter(v => v !== 'All')
      : value.Assigned_To;


    const payload = {
      Item_Id: edit ? updatepayload.Item_Id : 0,
      Req_Id: 0,
      Role_id: localStorage.getItem("emp_role_id"),
      Projectid: value.Project,
      clientid: selectedclient,
      itemname: value.Req_title,
      Description: value.description,
      itemtype: "Task",
      assign_by: localStorage.getItem("employee_id"),
      assign_to: cleanedAssignedTo,
      planned_hours: 0,
      item_status: value.Status,
      itempriority: value.Item_Priority,
      Severity: value.Severity,
      item_sdate: formattedDateTime,
      item_edate: formattedDateTime,
    };
    console.log("PAYLOAD", payload)

    try {
      const response = await Timesheetapi.post('api/Projects/addWorkItem', payload);
      if (response.data.status == 1) {
        getProjectList();
        message.success(`Task ${response.data.message}`);
      }
      setIsModalVisible(false);
      form.resetFields();
    } catch (error) {
      message.error("Submission error");
      console.error('Submission error')
    }
  }



  const getProjectHeader = () => {

    if (rawData.length > 0) {
      const projectLists = rawData.reduce((acc, curr) => {
        if (!acc.some(item => item.key === curr.Project_Id)) {
          acc.push(
            {
              label: curr.Project_name,
              key: curr.Project_Id
            });
        }
        return acc;
      }, []);

      const items = [{ label: 'All', key: 'All' }, ...projectLists].map((curr) => {
        const key = curr.key;
        const name = curr.label;

        return {
          key,
          label: (
            <span
              style={{
                width: '100%',
                fontWeight: selectedProjectTable == key ? 'bold' : 'normal',
                color: selectedProjectTable == key ? '#1677ff' : 'black',
              }}
            >
              {name}
            </span>
          ),
        };
      });
      const handleMenuClick = (info) => {
        setSelectedProjectTable(info.key)
      };

      return (
        <Dropdown
          menu={{ items, onClick: handleMenuClick }}
          trigger={['click']}
          className="w-full h-full cursor-pointer"
        >
          <a onClick={e => e.preventDefault()} className="hover:text-blue-500">
            <Space>
              Project Name<DownOutlined />
            </Space>
          </a>
        </Dropdown>
      );
    }
  }


  const getOwnerHeader = () => {

    const items = [
      {
        label: (
          <span style={{
            width: '100%',
            fontWeight: selectedOwner === 'All' ? 'bold' : 'normal',
            color: selectedOwner === 'All' ? '#1677ff' : 'Black',
          }}
          >
            By All
          </span>
        ),
        key: 'All',
      },
      {
        label: (
          <span style={{
            width: '100%',
            fontWeight: selectedOwner == localStorage.getItem('employee_id') ? 'bold' : 'normal',
            color: selectedOwner == localStorage.getItem('employee_id') ? '#1677ff' : 'Black',
          }}
          >
            By Me
          </span>
        ),
        key: localStorage.getItem('employee_id'),
      }
    ];

    const handleMenuClick = (info) => {
      setSelectedOwner(info.key);
      console.log('Selected:', info.key); // <-- Here you get the selected key
    };

    return (
      <Dropdown
        menu={{ items, onClick: handleMenuClick }}
        trigger={['click']}
        className="w-full h-full cursor-pointer"
      >
        <a onClick={e => e.preventDefault()} className="hover:text-blue-500">
          <Space>
            Assigned By<DownOutlined />
          </Space>
        </a>
      </Dropdown>
    );

  }

  // useEffect(() => {

  //   if (rawData.length > 0) {

  //     let selected = rawData.filter((item) => {
  //       const projectMatch = selectedProjectTable === 'All' || item.Project_Id == selectedProjectTable;
  //       const ownerMatch = selectedOwner === 'All' || item.Assigned_By_Id == selectedOwner;
  //       return projectMatch && ownerMatch;
  //     });

  //     console.log("select", selected);
  //     setFilterRequirementsList(selected);

  //   }
  // }, [selectedProjectTable, selectedOwner, rawData]);

  const columns = [
    {
      title: "Projects",
      dataIndex: "Project_name",
      key: "Project_name",
    },
    {
      title: "Tasks",
      dataIndex: "Req_Name",
      key: "Req_Name",
      sorter: (a, b) => a.Req_Name.localeCompare(b.Req_Name),
    },
    {
      title: 'Assigned By',
      dataIndex: "Assigned_By",
      key: "Assigned_By",

    },

    {
      title: "Assigned To",
      dataIndex: "Assigned",
      key: "Assigned",
      render: (text, record) => {
        return (
          <Tooltip title={record.Assigned_To}>
            <span>{record.Assigned}</span> </Tooltip>
        );
      },
    },
    {
      title: "State",
      dataIndex: "Item_Status",
      key: "Item_Status",
      render: (state) => {
        const colors = {
          'Rejected': "red",
          'Proposed': "#ff9d00",
          'Completed': 'red',
          'Open': "green",
          "In Progress": "blue"
        };
        return <Badge color={colors[state]} text={state} />;
      },
      sorter: (a, b) => a.Item_Status.localeCompare(b.Item_Status),
    },
    {
      title: "Start Date",
      dataIndex: "Start_date",
      key: "Start_date",
      sorter: (a, b) => new Date(a.Start_date) - new Date(b.Start_date),
    },
    {
      title: "End Date",
      dataIndex: "End_Date",
      key: "End_Date",
      sorter: (a, b) => new Date(a.End_Date) - new Date(b.End_Date),
    },
    {
      title: "Priority",
      dataIndex: "Item_Priority",
      key: "Item_Priority",
      sorter: (a, b) => {
        const priorityOrder = {
          "Low": 1,
          "Medium": 2,
          "High": 3,
          "Critical": 4,
        };

        return priorityOrder[a.Item_Priority] - priorityOrder[b.Item_Priority];
      },
    },

    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <div onClick={(e) => e.stopPropagation()}>
          <Space size="middle">
            <Tooltip title="Edit">
              <FaRegEdit
                style={{ color: "blue", cursor: "pointer" }}
                onClick={() => handleEdit(record)}
              />
            </Tooltip>
            <Tooltip title="Delete">
              <FaTrashAlt
                style={{ color: "red", cursor: "pointer" }}
                onClick={() => { setIsModalOpen(true); setdeletedata(record) }}
              // handleDelete(record)
              />
            </Tooltip>
          </Space>
        </div>
      ),
    },
  ];


  const handleEdit = async (record) => {

    let expected = [];
    let selected = []
    setSelectedClient(record.Client_Id)

    await Timesheetapi.get(`api/Projects/GetProjectWiseMember?Projectid=${record.Project_Id}&&Role_id=${localStorage.getItem("emp_role_id")}&&Emp_id=${localStorage.getItem("employee_id")}&&Client_id=${selectedclient}`).then((res) => {

      console.log(res.data.EmpData)
      const memberOption = res.data.EmpData
        .map(Team => ({
          value: Team.Emp_Id,
          label: Team.Emp_Name,
        }))
        .filter((item, index, self) =>
          index === self.findIndex(t => t.value === item.value)
        );
      setmembers([{ label: "All", value: "All" }, { label: "Assign to Me ", value: parseInt(localStorage.getItem("employee_id"), 10) }, ...memberOption])
      expected = [parseInt(localStorage.getItem("employee_id"), 10), ...memberOption.map(m => m.value)];
    })

    selected = JSON.parse(record.Assigned_To_Id);

    if (arraysAreEqualUnordered(expected, selected)) {
      selected = ["All", ...selected]
    } else {
      selected = selected
    }
    console.log("selectedselected", selected)

    console.log("Edit clicked for:", typeof (record.Client_Id), record);


    setStartDate(record.Start_date == null ? "" : dayjs(record.Start_date, 'DD-MM-YYYY'));
    setEndDate(record.End_Date == null ? "" : dayjs(record.End_Date, 'DD-MM-YYYY'));
    // setSelectedValue(record['Work Item Type'])

    let payload = {}
    setEdit(true);
    setSelectedAssignedToMembers(selected);
    form.setFieldsValue({
      client: record.Client_Id,
      Project: record.Project_Id,
      Req_title: record.Req_Name,
      description: record.Description,
      Assigned_Hours: record.Estimated_hours,
      Status: parseInt(record.Item_Status_Id, 10),
      start_date: record.Start_date == null ? "" : dayjs(record.Start_date, 'DD-MM-YYYY'),
      end_date: record.End_Date == null ? "-" : dayjs(record.End_Date, 'DD-MM-YYYY'),
      Severity: record.Severity,
      Item_Priority: parseInt(record.Item_Priority_Id, 10),
      Assigned_To: selected
    });

    setTimeout(() => {
      console.log("This runs after 2 seconds", form.getFieldValue());
    }, 2000);

    payload = {
      Item_Id: record.Item_Id,
      clientid: selectedclient,
      Projectid: record.Project_Id,
      Req_name: form.getFieldValue('Req_title'),
      Estimated_hours: form.getFieldValue('Assigned_Hours'),
      itemtype: record['Work Item Type'],
      Start_date: form.getFieldValue(dayjs(record.Start_date, 'DD-MM-YYYY')),
      End_date: form.getFieldValue(dayjs(record.End_Date, 'DD-MM-YYYY')),
      Req_status: form.getFieldValue('Status'),
      created_by: localStorage.getItem("employee_id"),
    }

    setupdatepayload(payload);
    setIsModalVisible(true)
  };

  const handleDelete = async (record) => {
    console.log("Delete clicked for:", record);
    await Timesheetapi.post(`api/Projects/DeleteWorkItem?Item_Id=${record.Item_Id}`).then(async (response) => {
      message.success("Work Item Deleted Successfully")

      const updatedList = rawData.filter(item => item.Item_Id !== record.Item_Id);
      setRawData(updatedList);

      console.log(rawData, "DATES")
    }).catch((err) => {
      message.error(err.message);
    })

  };
  const Compare = (data, state, type) => {
    let token = true;
    if (workItemState.length != 0) {
      if (!state.includes(data.Req_Status)) {
        token = false;
      }
    }
    if (workItemType.length != 0) {
      if (!type.includes(data['Work Item Type'])) {
        token = false;
      }
    }
    return token
  }
  useEffect(() => {
    let temp = RequirementsList.filter(a => Compare(a, workItemState, workItemType));
    setFilterRequirementsList(temp)
  }, [workItemState, workItemType])

  const handletitlechange = (e) => {
  }


  const confirmDelete = async () => {

    console.log(deledata, "sdee")
    let record = deledata
    console.log("Delete clicked for:", record);
    await Timesheetapi.post(`api/Projects/DeleteWorkItem?Item_Id=${record.Item_Id}`).then(async (response) => {
      message.success("Work Item Deleted Successfully")

      const updatedList = rawData.filter(item => item.Item_Id !== record.Item_Id);
      setRawData(updatedList);
      setIsModalOpen(false);
      console.log(rawData, "DATES")
    }).catch((err) => {
      message.error(err.message);
    })
  }

  return (

    <div className="mt-[30px]">


      <div className="flex items-center justify-between">

        <>
          <Modal
            title={
              <>
                <ExclamationCircleFilled
                  style={{ color: "orange", marginRight: "8px" }}
                />{" "}
                Confirm
              </>
            }
            visible={isModalOpen}
            onOk={() => setIsModalOpen(false)}
            onCancel={() => setIsModalOpen(false)}
            footer={[
              <Button key="cancel" onClick={() => setIsModalOpen(false)}>
                Cancel
              </Button>,
              <Button key="confirm" type="primary" onClick={() => confirmDelete()}>
                Delete
              </Button>,
            ]}
          >
            <p>Are you sure you want to delete this row?</p>
          </Modal>
        </>
        <div className="flex items-center gap-2">
          <div className="flex items-center gap-2">
            <div>
              <button
                onClick={() => handleChange()}
                className="flex items-center justify-center gap-2 bg-[#3b82f6] text-[14px] text-[#fff] px-5 w-[150px] py-[5px] rounded-[5px]"
              >
                <i className="fa fa-plus-circle text-[16px] relative top-[-1px]"></i> Add Task
              </button>
            </div>
          </div>
          <Select
            className="w-[150px]"
            showSearch
            value={selectedclientfilter}
            optionFilterProp="label"
            options={[
              {
                label: "All",
                value: "All"
              },
              ...clients
            ]}
            onChange={(e) => setSelectedclientfilter(e)}
          >
          </Select>

          <Select
            className="w-[150px]"
            showSearch
            value={selectedprojectfilter}
            optionFilterProp="label"
            options={
              selectedclientfilter === "All"
                ? [
                  {
                    label: "All",
                    value: "All"
                  }
                ]

                :
                [{
                  label: "All",
                  value: "All"
                },
                ...projectfilterlist
                ]
            }
            onChange={(e) => setSelectedprojectfilter(e)}
          >
            <option>All</option>
          </Select>

          <RangePicker
            defaultValue={[dayjs(today), dayjs(today)]}
            onChange={dateOnchange}
            allowClear={false}
            format="YYYY-MM-DD"
          />

        </div>

      </div>
      <div className="relative">
        <div>
          {isModalVisible && (
            <>
              <Modal className="workitem-popup task-popup" title={`${edit ? "Update a" : "Create a"} ${"Task"}`} visible={isModalVisible} onOk={toggleModal} onCancel={toggleModal} footer={null} // Disable default footer buttons
              >
                <div className="bg-white rounded-lg">
                  <Form form={form} onFinish={handleSubmit} layout="vertical">
                    <div style={{ maxHeight: 'calc(100vh - 200px)', overflow: 'hidden auto', marginInline: '-23px', paddingInline: '20px' }}>
                      <div className="grid grid-cols-3 gap-4">
                        <div>
                          <Form.Item
                            label="Client"
                            name="client"
                            placeholder="Please select"
                            rules={[{ required: true, message: 'Please select a Client' }]}
                          >
                            <Select className="h-10"
                              showSearch
                              placeholder="Select Client"
                              value={selectedclient}
                              optionFilterProp="label"
                              options={clients}
                              onChange={(e) => setSelectedClient(e)}
                            >

                            </Select>

                          </Form.Item>
                        </div>
                        <Form.Item
                          label="Project"
                          name="Project"
                          rules={[{ required: true, message: 'Please select a Project' }]}
                        >
                          <Select
                            showSearch
                            optionFilterProp="label"
                            placeholder="Select Project"
                            options={Requirements}
                            onChange={handleClientChange}
                            className="h-10"
                          >
                          </Select>

                        </Form.Item>

                        {/* </div> */}




                        <div>
                          <Form.Item
                            label="Status"
                            name="Status"

                            placeholder="Please select"
                            rules={[{ required: true, message: 'Please select a Status' }]}
                          >
                            <Select className="h-10"
                              //disabled={true}
                              defaultValue={1}
                              options={Reqstatus}>

                            </Select>

                          </Form.Item>
                        </div>

                      </div>
                      <div className="grid grid-cols-2 gap-4">
                        <div>
                          <Form.Item
                            label="Priority"
                            name="Item_Priority"
                            placeholder="Please select"
                            rules={[{ required: true, message: 'Please select a Priority' }]}
                          >
                            <Select
                              defaultValue={3}
                              options={[
                                { value: 1, label: "Low" },
                                { value: 2, label: "Medium" },
                                { value: 3, label: "High" },
                                { value: 4, label: "Critical" },

                              ]}
                              className="h-10"
                              onChange={(selectedOption) => console.log(selectedOption)} // Handle the selected option
                            />

                          </Form.Item>

                        </div>

                        <div>
                          <Form.Item
                            label="Assigned To"
                            name="Assigned_To"
                            placeholder="Please select"
                            rules={[{ required: true, message: 'Please select a value' }]}
                          >
                            <Select
                              mode="multiple"
                              className="h-10"
                              showSearch
                              optionFilterProp="label"
                              options={members}
                              //New
                              defaultValue={"All"}
                              allowClear
                              value={selectedAssignedToMembers}
                              onChange={handleAssignedToChange}
                              placeholder="Select Employees"
                              maxTagCount={0}
                              tagRender={() => {
                                if (members.length > 0) {
                                  if (selectedAssignedToMembers.includes('All')) {
                                    return (
                                      <div style={{ padding: '3px 8px', borderRadius: '4px' }}>
                                        All Employees
                                      </div>
                                    );
                                  } else {
                                    const count = selectedAssignedToMembers.length;
                                    return (
                                      <div style={{ padding: '3px 8px', borderRadius: '4px' }}>
                                        {`${count} Employee${count === 1 ? '' : 's'}`}
                                      </div>
                                    );
                                  }
                                } else {
                                  return (
                                    <span
                                      style={{
                                        padding: '3px 8px',
                                        borderRadius: '6px',
                                        color: 'rgba(0, 0, 0, 0.25)', // Placeholder gray
                                        fontSize: '13px',
                                        lineHeight: '22px',
                                        display: 'inline-block',
                                      }}
                                    >
                                      Select Employees
                                    </span>
                                  );
                                }
                              }}


                            >
                            </Select>
                          </Form.Item>
                        </div>
                      </div>
                      <div className="grid grid-cols-1" >
                        <div>
                          <Form.Item
                            label={`Task`}
                            name="Req_title"
                            rules={[{ required: true, message: 'Please enter the title' }]}
                          >
                            <TextArea placeholder="Enter a Title" className="pt-2" style={{ height: '60px' }} onChange={(e) => handletitlechange(e)}></TextArea>
                          </Form.Item>

                        </div>
                        <div>
                          <Form.Item
                            label={`Description`}
                            name="description"
                          >
                            <TextArea placeholder="Enter a Description" className="pt-2" style={{ height: '120px' }} ></TextArea>
                          </Form.Item>
                        </div>
                      </div>
                    </div>

                    <Form.Item className="text-right footer-form-item">
                      <Button className="w-[100px]" type="default" onClick={toggleModal} style={{ marginRight: '8px' }}>
                        Cancel
                      </Button>
                      <Button className="w-[100px]" type="primary" htmlType="submit">
                        {edit ? "Update" : "Create"}
                      </Button>
                    </Form.Item>
                  </Form>
                </div>
              </Modal>


            </>
          )}

        </div>
      </div>
      <div
        className="ticket-table absolute w-[98%] mt-[10px] task-table"
        style={{ maxHeight: "calc(100vh - 140px)", overflow: "auto" }}
      >
        {loading ? (
          <>
            <Spin tip="Loading...">
              <div className="overflow-auto custom-table">
                <Table
                  dataSource={filterRequirementsList}
                  columns={columns}
                  pagination={false}
                />
              </div>
            </Spin>
          </>
        ) : (
          <>
            <Table
              dataSource={filterRequirementsList}
              columns={columns}
              pagination={{
                current: pagination.current,
                pageSize: pagination.pageSize,
                pageSizeOptions: ['10', '20', '50', '100'],
              }}
              onChange={handleTableChange}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default Ticket;
